<template>
  <div class="item-refine" v-show="show">
    <button
      class="item-refine__button"
      :class="[val.refine ? 'is-active' : '']"
      v-for="(val, index) in stateLists"
      @click="clickEvent(val)">
      <div class="item-refine__icon">
        <img class="item-refine__icon-img" src="/choice/img/icon/check.svg" alt="">
      </div>
      <div class="item-refine__body">
        {{ val.name }}
      </div>
    </button>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      show: false,
      active: [],
    }
  },
  computed: {
    ...mapState({
      stateLists: state => state.step.lists,
    })
  },
  watch: {
    stateLists: {
      handler(val) {
        this.dataSet()
      },
      deep: true
    },
  },
  created() {
    this.dataSet()
  },
  methods: {
    dataSet() {
      if (this.stateLists && this.stateLists.length >= 2) {
        this.show = true
      } else {
        this.show = false
      }
    },
    clickEvent(val) {
      this.$store.commit('step/listSelectSet', val)
    },
  }
}
</script>



<style lang="scss">
.item-refine {
  $e: &;
  touch-action: manipulation;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 0;
  background-color: $oc-gray-1;
  padding-top: 20px;
  padding-bottom: 20px;
  @include breakpoints-min(md) {
    background-color: transparent;
  }
  &__button {
    cursor: pointer;
    display: block;
    appearance: none;
    transition: $transition;
    position: relative;
    outline: none;
    border-radius: 4px;
    border: 1px solid #dbd5d3;
    background-color: #fff;
    color: $oc-gray-7;
    font-size: 11px;
    line-height: 1.4;
    width: calc(33% - 8px);
    margin: 4px;
    padding: 0;
    &::before {
      content:"";
      display: block;
      padding-top: 100%;
    }
    @include breakpoints-min(sm) {
      width: calc(25% - 8px);
    }
    @include breakpoints-min(md) {
      border-radius: 99px;
      text-align: center;
      line-height: 30px;
      width: auto;
      min-width: 144px;
      padding: 6px 24px 6px 52px;
      &::before {
        display: none;
      }
    }

    &.is-active {
      border: 1px solid #806458;
      background-color: #806458;
      color: #fff;
      #{$e}__icon {
        border: 1px solid #fff;
      }
      #{$e}__icon-img {
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  &__icon {
    display: block;
    overflow: hidden;
    position: absolute;
    top: 6px;
    left: 6px;
    border-radius: 50%;
    border: 1px solid #dbd5d3;
    background-color: #fff;
    width: 18px;
    height: 18px;
    @include breakpoints-min(md) {
      width: 30px;
      height: 30px;
    }
  }
  &__icon-img {
    display: block;
    transition: 0.4s ease-out;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    width: 8px;
    @include breakpoints-min(md) {
      width: 12px;
    }
  }
  &__body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    margin-top: 4px;
    padding-left: 16px;
    padding-right: 16px;
    @include breakpoints-min(md) {
      transform: none;
      position: static;
      margin-top: 0;
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
